import React, { createContext, useState, useContext, useEffect } from "react";
import { fetchCurrentEphemeris, fetchKundliFromBirthData } from "../services/kundliService";

// Create the context
const KundliContext = createContext();

// Provider component
export const KundliProvider = ({ children }) => {
  const [kundliData, setKundliData] = useState(null);
  const [kundliChartData, setKundliChartData] = useState(null);
  const [currentEphemeris, setCurrentEphemeris] = useState(null);

  // Initialize kundliData from localStorage on app load
  useEffect(() => {
    const storedData = localStorage.getItem("kundliData");
    const storedChartData = localStorage.getItem("kundliChartData");
    if (storedData) {
      const parsedKundli = JSON.parse(storedData);
      setKundliData(parsedKundli);
      
      if (storedChartData) {
        const parsedChart = JSON.parse(storedChartData);
        setKundliChartData(parsedChart); // Instant load from cache

        // Stale-while-revalidate: Always fetch latest from backend in the background
        fetchKundliFromBirthData({
          date: parsedKundli.dob,
          time: parsedKundli.time,
          lat: parsedKundli.lat,
          lon: parsedKundli.lon
        })
          .then(res => {
            setKundliChartData(res);
            localStorage.setItem("kundliChartData", JSON.stringify(res));
          })
          .catch(err => {
            console.error("Background refresh failed:", err);
          });
      }
    }

    // Fetch live ephemeris globally
    const loadEphemeris = async () => {
      try {
        const ephem = await fetchCurrentEphemeris();
        setCurrentEphemeris(ephem);
      } catch (err) {
        console.error("Failed to load global ephemeris:", err);
      }
    };
    loadEphemeris();
  }, []);

  return (
    <KundliContext.Provider value={{ kundliData, setKundliData, kundliChartData, setKundliChartData, currentEphemeris }}>
      {children}
    </KundliContext.Provider>
  );
};

// Custom hook to use the context
export const useKundli = () => useContext(KundliContext);

// (Optional) Export default for fallback use
export default KundliContext;
